import React, { useState, useEffect, useRef } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import api from '@helpers/api';
import { useCommunity } from "contexts/community";
import Parser from '@helpers/parser';
import { LoopRounded } from '@mui/icons-material';
import Popper from '@fragments/Popper';
import { Table, Text } from '@fragments';
import StatusChip from '@fragments/StatusChip';

export function SubscriptionTable({ userId }) {
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pages: 0,
        records: 0,
        page: 1
    });
    const popperRef = useRef();

    const { community, loading: communityLoading } = useCommunity();

    useEffect(() => {
        if (userId && !communityLoading) {
            fetchSubscriptions();
        }
    }, [userId, communityLoading]);

    console.log(subscriptions);

    const fetchSubscriptions = async (pageNumber = 1) => {
        try {
            if (loading) return;
            setLoading(true);
            const { data: response } = await api.get(`community/subscription/subscriber/${userId}?page=${pageNumber}`);

            let list = response.data || [];
            if (list.length > 0) {
                list = list.map(subscription => {
                    subscription.community_info = community.get(subscription.community);
                    return subscription;
                });
            }

            setSubscriptions([...list]);
            setPagination({
                pages: response.pages || 0,
                records: response.records || 0,
                page: response.page || 1
            });
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            setSubscriptions([]);
            setPagination({ pages: 0, records: 0, page: 1 });
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };



    const handleOpenPopper = (event, subscription) => {
        const options = [
            {
                id: 'cancel',
                label: 'Cancelar assinatura',
                icon: <DeleteRoundedIcon fontSize="small" />,
                variant: 'danger',
                onClick: () => {
                    // Abrir o Confirm ao invés de executar diretamente
                    window.openConfirm({
                        title: 'Cancelar assinatura',
                        subtitle: 'Tem certeza que deseja cancelar esta assinatura?',
                        variant: 'danger',
                        confirmText: 'Cancelar a assinatura',
                        cancelText: 'Manter ativa',
                        buttons: [
                            {
                                text: "Cancelar a assinatura",
                                onClick: async () => {
                                    try {
                                        const { data } = await api.delete('subscription?id=' + subscription.id);
                                        fetchSubscriptions()
                                    } catch (error) {
                                        console.error('Erro ao cancelar assinatura:', error);

                                    }
                                },
                            },
                            {
                                text: "Manter ativa",
                                variant: "text",
                            },
                        ]
                    });
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    };

    const columns = [
        {
            id: 'community',
            title: 'Comunidade',
            grow: 1,
            className: 'pl-1',
            customRender: (data) => {
                const StatusComponent = {
                    'active': StatusChip.Success,
                    'canceled': StatusChip.Error,
                    'expired': StatusChip.Alert,
                    'unknown': StatusChip.Default,
                }[data.status || 'default'];

                return (
                    <>
                        <img
                            src={data.community_info?.banner || ''}
                            className="community-row-banner"
                        />
                        <Text.span contrast={7} weight={400}>
                            {data.community_info?.name || 'N/A'}
                        </Text.span>
                        <StatusComponent text={Parser.payment.subscriptionStatus(data.status)} />
                    </>
                );
            }
        },
        {
            id: 'plan',
            title: 'Plano',
            render: (data) => data.plan?.label || 'N/A'
        },
        {
            id: 'recurrence',
            title: 'Recorrência',
            align: 'center',
            customRender: (data) => Parser.interval.adjective(data.interval)
        },
        {
            id: 'next_invoice',
            title: 'Próxima fatura',
            render: (data) => formatDate(data.timestamps?.expiration)
        }
    ];

    return (
        <>
            <Text.h3 value="Assinaturas" className='mb-2 mt-5' left={<LoopRounded />} />
            <Table
                id="community-user-subscriptions-table"
                columns={columns}
                data={subscriptions}
                loading={loading}
                loadingRows={4}
                enablePagination={true}
                pages={pagination.pages}
                contained={true}
                records={pagination.records}
                emptyMessage="Nenhuma assinatura encontrada"
                page={pagination.page}
                onSelectPage={fetchSubscriptions}
                actionsComponent={(subscription) => (
                    <button
                        className={`action-button ${subscription.status?.toLowerCase() === 'canceled' ? 'disabled' : ''}`}
                        onClick={(event) => handleOpenPopper(event, subscription)}
                        disabled={subscription.status?.toLowerCase() === 'canceled'}
                    >
                        <MoreVertIcon />
                    </button>
                )}
            />
            <Popper controlRef={popperRef} />
        </>
    );
}
